import * as faceapi from "@vladmandic/face-api";

const MODEL_URL = `${process.env.PUBLIC_URL || ""}/models`;
export const MATCH_THRESHOLD = 0.55;
export const EAR_OPEN = 0.26;   // eyes clearly open
export const EAR_CLOSED = 0.19; // eyes closed (blink)
export const TURN_CENTER = 0.06; // head facing forward
export const TURN_ON = 0.16;     // head clearly turned left/right

let loadPromise = null;
export function loadFaceModels() {
  if (!loadPromise) {
    loadPromise = (async () => {
      await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
      await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
      await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
    })().catch((e) => { loadPromise = null; throw e; });
  }
  return loadPromise;
}

const detectorOptions = new faceapi.TinyFaceDetectorOptions({ inputSize: 320, scoreThreshold: 0.5 });

const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
function eyeAspectRatio(p) {
  // p = [p1..p6] outer→ around the eye
  return (dist(p[1], p[5]) + dist(p[2], p[4])) / (2 * dist(p[0], p[3]));
}

// Full detection: returns { descriptor:number[128], ear:number } or null.
export async function detectFace(video) {
  if (!video || video.readyState < 2) return null;
  const res = await faceapi
    .detectSingleFace(video, detectorOptions)
    .withFaceLandmarks()
    .withFaceDescriptor();
  if (!res) return null;
  const lm = res.landmarks.positions;
  const left = [36, 37, 38, 39, 40, 41].map((i) => lm[i]);
  const right = [42, 43, 44, 45, 46, 47].map((i) => lm[i]);
  const ear = (eyeAspectRatio(left) + eyeAspectRatio(right)) / 2;
  // Head yaw: nose tip (30) offset from the eye-corner midpoint, normalised by eye span.
  const eyeMidX = (lm[36].x + lm[45].x) / 2;
  const eyeSpan = Math.abs(lm[45].x - lm[36].x) || 1;
  const yaw = (lm[30].x - eyeMidX) / eyeSpan;
  return { descriptor: Array.from(res.descriptor), ear, yaw };
}

// Descriptor only — used during enrolment capture.
export async function getDescriptor(video) {
  const res = await detectFace(video);
  return res ? res.descriptor : null;
}

export function bestDistance(descriptor, stored) {
  if (!stored || !stored.length) return Infinity;
  const a = new Float32Array(descriptor);
  let min = Infinity;
  for (const s of stored) {
    const d = faceapi.euclideanDistance(a, new Float32Array(s));
    if (d < min) min = d;
  }
  return min;
}
